/**
 * Detects the browser's preferred language and maps it to our supported locales
 * @returns The preferred locale code ('en', 'fi', 'sv') or null if not determinable
 */
export function detectBrowserLanguage(): 'en' | 'fi' | 'sv' | null {
  if (typeof window === 'undefined') {
    return null;
  }

  // Get browser's preferred languages
  const languages = navigator.languages || [navigator.language];

  // Check each language in order of preference
  for (const lang of languages) {
    // Extract the base language code (e.g., 'en' from 'en-US')
    const baseLang = lang.toLowerCase().split('-')[0];

    // Map to our supported locales
    if (baseLang === 'en') {
      return 'en';
    }
    if (baseLang === 'fi') {
      return 'fi';
    }
    if (baseLang === 'sv') {
      return 'sv';
    }
  }

  // Default to English if no match found
  return 'en';
}

/**
 * Checks if the locale mismatch prompt has already been shown to the user
 */
export function hasShownLocalePrompt(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }
  return localStorage.getItem('localePromptShown') === 'true';
}

/**
 * Marks that the locale mismatch prompt has been shown
 */
export function markLocalePromptShown(): void {
  if (typeof window === 'undefined') {
    return;
  }
  localStorage.setItem('localePromptShown', 'true');
}





